<template>
    <div>
        <!-- DIALOGO DE CONFIRMACION -->
        <q-dialog v-model="dialogConfirm" persistent>
            <q-card>
                <q-card-section class="row items-center">
                    <div class="row no-wrap q-pa-md ">
                        <div class="column text-center">
                            <q-avatar size="80px" icon="mdi-delete-alert" color="warning" text-color="white" />
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column text-center">
                            <span class="text-h5 q-ml-lg">¿Estas seguro de eliminar la Sede <strong>{{ item.sede
                            }}</strong> .?</span>
                        </div>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn label="CANCELAR" @click="cancelarDelete()" />
                    <q-btn label="Aceptar" color="primary" @click="DeleteItem()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-card style="width: 700px; max-width: 80vw;background: #f8fcff">
            <q-bar class="bg-primary text-white">
                <q-icon name="mdi-bank" />
                <div>Sedes</div>
                <q-space />
                <q-btn dense flat icon="close" v-close-popup>
                    <q-tooltip>Close</q-tooltip>
                </q-btn>
            </q-bar>
            <q-card-section>
                <q-form class="q-gutter-md">
                    <q-table :loading="loading" dense :data="dataList" :columns="columns">
                        <template v-slot:loading>
                            <q-inner-loading showing color="primary" />
                        </template>
                        <template v-slot:top>
                            <q-toolbar-title class="row col q-pb-sm">
                                Sede
                                <q-space />
                                <q-btn v-if="template == false" push round icon="mdi-plus" @click="crearItem()" />
                                <q-btn v-if="template == true" push round icon="mdi-minus" class="q-mr-sm"
                                    @click="cancelar" />
                                <q-btn v-if="template == true && item._id == ''" color="primary" push round
                                    icon="mdi-content-save" @click="PostItem()" />
                            </q-toolbar-title>

                            <template class="row " v-if="template == true">
                                <div class="col-12 q-mb-md">
                                    <q-input dense filled v-model="item.sede" label="Nombre de la Sede" />
                                </div>
                            </template>
                        </template>
                        <template v-slot:body="props">
                            <q-tr :props="props">
                                <q-td auto-width key="acciones">
                                    <q-btn v-if="props.row.estatus == 'Vigente'" size="md" style="color:#CC003D" rounded
                                        flat dense @click="eliminarItem(props.row)" icon="mdi-delete">
                                        <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                            content-style="font-size: 14px">Eliminar</q-tooltip>
                                    </q-btn>

                                </q-td>
                                <q-td key="sede" :props="props">{{ props.row.sede }}</q-td>

                            </q-tr>
                        </template>
                    </q-table>
                </q-form>
            </q-card-section>
        </q-card>
    </div>
</template>
<script>
import { format } from 'date-fns';
import { QSpinnerFacebook } from 'quasar'
import moment from 'moment';
import axios from "axios";
export default {

    components: {
    },

    data() {
        return {
            template: false,
            columns: [
                { name: 'acciones', align: 'center', label: 'Acciones', field: 'acciones', classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'sede', align: 'center', label: 'Sede', field: 'sede', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
            ],
            loading: false,
            dialogConfirm: false,
        }
    },
    computed: {
        usuarioStore() {
            return this.$store.state.usuario
        },
        item() {
            return this.$store.state.sedeStore
        },
        dataList() {
            return this.$store.state.dataSedesStore
        }

    },
    created() {
        this.GetSedes()
    },
    methods: {
        crearItem() {
            this.template = true
        },
        eliminarItem(item) {
            this.$store.state.sedeStore = { ...item }
            this.dialogConfirm = true
        },
        cancelar() {
            this.template = false
            this.$store.state.sedeStore = {
                _id: '',
                sede: '',
                usuario_creador: this.usuarioStore.email,
                fecha_creacion: '',
                estatus: 'Vigente'
            }
        },
        cancelarDelete() {
            this.$store.state.sedeStore = {
                _id: '',
                sede: '',
                usuario_creador: this.usuarioStore.email,
                fecha_creacion: '',
                estatus: 'Vigente'
            }
            this.dialogConfirm = false

        },
        async PostItem() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }
            if (this.item.sede == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique el nombre de la Sede.' })
                return;
            }

            let fecha = new Date()
            let fechaC = format(fecha, "yyyy-MM-dd HH:mm:ss");
            this.item.fecha_creacion = fechaC
            this.$q.loading.show({ spinner: QSpinnerFacebook, spinnerColor: 'white', spinnerSize: 140, message: 'Guardando Sede. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.post('Configuracion/PostSedes/' + this.usuarioStore.baseDatos, this.item)
                this.$q.notify({ position: 'top-right', type: 'positive', message: `Información guardada exitosamente.` })
                console.log(respuesa)
                this.$q.loading.hide()
                this.$store.state.sedeStore.sede = ''
                await this.GetSedes();
            } catch (error) {
                this.$q.loading.hide()
                console.log(error)
            }
        },

        async DeleteItem() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }
            this.$q.loading.show({ spinner: QSpinnerFacebook, spinnerColor: 'white', spinnerSize: 140, message: 'Eliminando Sede. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.post(`Configuracion/DeleteSede/` + this.usuarioStore.baseDatos + '/' + this.item._id,)
                this.$q.notify({ position: 'top-right', type: 'positive', message: `La Sede se ha eliminado correctamente.` })
                console.log(respuesa)
                this.$q.loading.hide()
                this.cancelarDelete();
                await this.GetSedes();

            } catch (error) {
                this.$q.loading.hide()
                console.log(error)
            }
        },
        async GetSedes() {
            this.loading = true
            try {
                let respuesa = await axios.get('Configuracion/GetSedesTodos/' + this.usuarioStore.baseDatos)
                console.log(respuesa)
                this.loading = false
                this.$store.state.dataSedesStore = respuesa.data
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
    }
}
</script>